import React from "react";
import { Clock, CreditCard, LayoutDashboard, Search, Star, Zap } from "lucide-react";

const FEATURES = [
  {
    icon: Search,
    title: "Discover",
    description: "Search and compare spaces, accommodation and experiences near you or wherever you are headed.",
  },
  {
    icon: Clock,
    title: "Real-Time Availability",
    description: "Know what is available before you book. No calling ahead, no waiting on a reply.",
  },
  {
    icon: Zap,
    title: "Instant Booking",
    description: "Book without back-and-forth calls or emails. Confirm your reservation in under two minutes.",
  },
  {
    icon: CreditCard,
    title: "Secure Payments",
    description: "Pay securely online using local and international payment methods built for African markets.",
  },
  {
    icon: Star,
    title: "Verified Reviews",
    description: "Every review is from a verified booking. Make decisions with real confidence.",
  },
  {
    icon: LayoutDashboard,
    title: "One Place",
    description: "Manage every booking — work, stay and play — from one account, one dashboard.",
  },
];

export default function ShiftSection() {
  return (
    <section className="bg-[#f5f8ff] py-20">
      <div className="mx-auto max-w-[1440px] px-[16px] sm:px-8">
        <div className="grid grid-cols-1 items-end gap-6 lg:grid-cols-2 lg:gap-16">
          <div>
            <p className="text-[14px] font-semibold uppercase leading-5 tracking-[1.4px] text-[#017bef]">The Shift</p>
            <h2 className="pt-[12px] text-[36px] font-bold leading-[1.2] tracking-[-1.2px] text-[#0a0a0a] sm:text-[48px] sm:leading-[60px]">
              The Way We Work, Stay and Play is Changing
            </h2>
          </div>
          <p className="text-[18px] leading-[29.25px] text-[#717182]">
            People increasingly expect the same flexibility and convenience from physical spaces that they already enjoy
            from digital platforms. SPACIA closes that gap.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-[20px] pt-14 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map(({ icon: Icon, title, description }) => (
            <div key={title} className="rounded-2xl border-[1px] border-solid border-[#e5e7eb] bg-white p-7">
              <div className="flex size-11 items-center justify-center rounded-[14px] bg-[#017bef]/[0.08]">
                <Icon className="size-5 text-[#017bef]" />
              </div>
              <h3 className="pt-[20px] text-[18px] font-semibold leading-[27px] text-[#0a0a0a]">{title}</h3>
              <p className="pt-2 text-[14px] leading-[22.75px] text-[#717182]">{description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
